import { initializeSentry } from '@repo/observability/client';

export { onRouterTransitionStart } from '@repo/observability/client';

initializeSentry();
